import SEO from '../../../components/base/SEO';
import Header from './components/Header';
import Hero from './components/Hero';
import Merits from './components/Merits';
import RankingList from '../../free/components/RankingList';
import SelectionGuide from './components/SelectionGuide';
import FAQ from '../../free/components/FAQ';
import Footer from './components/Footer';
import Breadcrumb from '../../../components/feature/Breadcrumb';

export default function FreeAnnualFeePage() {
  const structuredData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Article',
        headline: '年会費無料クレジットカードおすすめランキング｜永年無料で高還元',
        description: '年会費永年無料のクレジットカードを徹底比較。大手ECモール系カード、三井住友カード（NL）など人気カードのメリット・デメリット、選び方のポイントを詳しく解説します。',
        author: {
          '@type': 'Organization',
          name: 'クレジットカード比較'
        },
        datePublished: '2026-01-01',
        dateModified: new Date().toISOString().split('T')[0],
        image: 'https://public.readdy.ai/ai/img_res/91bc76e11ab8a7c85d5d245d62ae8425.jpg'
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'ホーム',
            item: 'https://yourdomain.com/'
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: '記事一覧',
            item: 'https://yourdomain.com/#articles'
          },
          {
            '@type': 'ListItem',
            position: 3,
            name: '年会費無料クレジットカード',
            item: 'https://yourdomain.com/articles/free-annual-fee'
          }
        ]
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '年会費無料のクレジットカードは本当にずっと無料ですか？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'はい、「永年無料」と記載されているカードは、条件なしでずっと無料です。ただし、「初年度無料」や「条件付き無料」のカードもあるので、申込前に必ず確認しましょう。'
            }
          },
          {
            '@type': 'Question',
            name: '年会費無料カードでもポイントは貯まりますか？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'はい、年会費無料カードでも通常通りポイントが貯まります。大手ECモール系カードは1.0%、リクルートカードは1.2%など、有料カードに劣らない高還元率のカードも多数あります。'
            }
          },
          {
            '@type': 'Question',
            name: '年会費無料カードのデメリットは何ですか？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '主なデメリットは、付帯保険が少ない、空港ラウンジが使えない、ステータス性が低いなどです。ただし、日常使いには十分な機能を備えています。'
            }
          }
        ]
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="年会費無料クレジットカードおすすめランキング｜永年無料で高還元"
        description="年会費永年無料のクレジットカードを徹底比較。大手ECモール系カード、三井住友カード（NL）など人気カードのメリット・デメリット、選び方のポイントを詳しく解説します。"
        keywords="クレジットカード,年会費無料,永年無料,大手ECモール系カード,三井住友カード,おすすめ,ランキング"
        canonicalUrl="https://yourdomain.com/articles/free-annual-fee"
        ogImage="https://readdy.ai/api/search-image?query=premium%20credit%20cards%20with%20zero%20annual%20fee%20label%20modern%20design%20on%20clean%20white%20background%20professional%20product%20photography%20high%20quality%20detailed%20sharp%20focus&width=1200&height=630&seq=free-fee-og&orientation=landscape"
        structuredData={structuredData}
      />
      <Header />
      <Breadcrumb items={[
        { label: 'ホーム', path: '/' },
        { label: '記事一覧', path: '/#articles' },
        { label: '年会費無料クレジットカード' }
      ]} />
      <Hero />
      <Merits />
      <RankingList />
      <SelectionGuide />
      <FAQ />
      <Footer />
    </div>
  );
}
